import { renderToStringWithData } from '@apollo/client/react/ssr/index.js';
export const renderJSXElementToString = async (TheElement, client) => {
    const html_content = await renderToStringWithData(TheElement);
    const apollo_state = client.extract();
    return {
        html_content,
        apollo_state,
    };
};
//# sourceMappingURL=renderJSXElementToString.js.map